import { ArrowIcon, Component } from "./styles";

interface BackArrowButtonProps {
  onClick: () => void;
}

export function BackButton({ onClick }: BackArrowButtonProps) {
  return (
    <Component onClick={onClick}>
      <ArrowIcon />
    </Component>
  );
}
